import { render, staticRenderFns } from "./ContactHeaderIcon.vue?vue&type=template&id=1333689f&scoped=true&"
import script from "./ContactHeaderIcon.vue?vue&type=script&lang=js&"
export * from "./ContactHeaderIcon.vue?vue&type=script&lang=js&"
import style0 from "./ContactHeaderIcon.vue?vue&type=style&index=0&id=1333689f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1333689f",
  null
  
)

export default component.exports